import { HubConnectionBuilder, LogLevel, HttpTransportType, HubConnectionState } from '@microsoft/signalr'
import config from '@/config'

const url = config.api

export default {
  install (Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl(`${url.consig}/leadsHub`, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: retryContext => {
          if (retryContext.elapsedMilliseconds < 120000) return 5000
          else return null
        }
      })
      .configureLogging(LogLevel.None)
      .build()

    connection.startIfNotConnected = async () => {
      if (connection.state === HubConnectionState.Disconnected) await connection.start()
    }

    Vue.prototype.$leadsHub = connection
  }
}



// WEBPACK FOOTER //
// ./src/service/websocket/leadsHub.js